export const reasonAbortOrder = [
	{ value: 'INVALID_ORDER', label: 'order.modal.abortOrder.INVALID_ORDER' },
	{ value: 'CANCELLED_BY_CLIENT', label: 'order.modal.abortOrder.CANCELLED_BY_CLIENT' },
	{ value: 'OTHER', label: 'order.modal.abortOrder.OTHER' }
]
